import { useQuery } from '@tanstack/react-query';

import { getFavorites } from '@libs/api-proxy-client';

import { useUserSession } from '../../hooks/useUserSession';
import { useStore } from '../../providers/StoreProvider';
import { FAVORITES_QUERY_KEY } from './queryKey';

const SIX_HOURS = 6 * 3600000;

type UseFavoritesQueryProps = {
    storeId?: string | null;
};

export const useFavoritesQuery = ({ storeId }: UseFavoritesQueryProps = {}) => {
    const { user } = useUserSession();
    const { selectedStoreId } = useStore();
    const effectiveStoreId = storeId ?? selectedStoreId ?? null;

    return useQuery({
        queryKey: [FAVORITES_QUERY_KEY, user?.customerprofileid?.toString()],
        queryFn: () => getFavorites({ storeId: effectiveStoreId }),
        select: data => (data && 'items' in data ? data?.items : []),
        staleTime: SIX_HOURS,
        enabled: Boolean(user?.customerprofileid),
    });
};
